export const COMPANY_LIST_TYPES = ["EXHIBITORS", "SPONSORS"] as const;
export type CompanyListType = (typeof COMPANY_LIST_TYPES)[number];

/** Accepts SPONSORS | EXHIBITORS. Anything else is treated as "no filter". */
export function parseCompanyListType(
  type?: string | null
): CompanyListType | undefined {
  const normalized = type?.trim().toUpperCase();
  if (normalized === "EXHIBITORS" || normalized === "SPONSORS") {
    return normalized;
  }
  return undefined;
}
